import React, {memo} from 'react';
import Box from '@mui/material/Box';
import dynamic from 'next/dynamic';
import Facebook from 'public/images/blog-detail/facebook.svg';
import LinkedIn from 'public/images/blog-detail/linkedin.svg';
import Pinterest from 'public/images/blog-detail/pinterest.svg';
import twitter from 'public/images/blog/twitter-newlogo.svg';
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));

interface ShareBarProps {
    shareUrl: string;
}

// Plain social-share URLs — replaces the react-share dependency. These are static
// share endpoints, so crawlable <a> links are lighter and better for SEO.
const shareLinks = {
    facebook: (url: string) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    twitter: (url: string) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}`,
    linkedin: (url: string) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    pinterest: (url: string) => `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(url)}&media=${encodeURIComponent(url)}`
};

/**
 * Memoized social-share bar shared by blog/[blogsDetails].tsx and use-cases/[useCase].tsx.
 * Extracted from inline render functions to prevent recreation on every parent render.
 */
const ShareBar = ({shareUrl}: ShareBarProps) => (
    <Box className="social-media-wrapper" sx={{padding: '15px 8px !important', display: 'flex', alignItems: 'center', gap: '15px'}}>
        <a href={shareLinks.facebook(shareUrl)} target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook">
            <DisplayImage src={Facebook} alt="Facebook" />
        </a>

        <a href={shareLinks.twitter(shareUrl)} target="_blank" rel="noopener noreferrer" aria-label="Share on X">
            <DisplayImage src={twitter} alt="twitter" />
        </a>

        <a href={shareLinks.linkedin(shareUrl)} target="_blank" rel="noopener noreferrer" aria-label="Share on LinkedIn">
            <DisplayImage src={LinkedIn} alt="LinkedIn" />
        </a>

        <a href={shareLinks.pinterest(shareUrl)} target="_blank" rel="noopener noreferrer" aria-label="Share on Pinterest">
            <DisplayImage src={Pinterest} alt="Pinterest" />
        </a>
    </Box>
);

export default memo(ShareBar);
